module.exports = __webpack_public_path__ + "static/podio-470b2d16f85f07185a41045b9a522ca1.svg";